import React from "react";

import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { ColDef } from "ag-grid-community";
import { useSelector } from "react-redux";

import AgGridContainer from "components/AgGrid/AgGridContainer";

import { AgGridTables } from "constants/aggrid";
import { LedgerAccountColumnDef } from "constants/columnDefinitions/ledgerAccount";
import { ModalTypes } from "constants/navigation";

import { AutoCreateInAgrinousConfirmation } from "containers/Settings/Billing/Accounts/AutoCreateInAgrinousConfirmation";
import { AutoCreateInXeroConfirmation } from "containers/Settings/Billing/Accounts/AutoCreateInXeroConfirmation";

import { openModalLink } from "lib/navigation";

import {
  LedgerAccountAgGridRow,
  selectLedgerAccountsAgGridData,
} from "selectors/aggrid/ledgerAccounts";

import { useCanCreateLedgerAccountPermission, useToggle } from "hooks";

export const columnDefs = Object.values(
  LedgerAccountColumnDef,
) as ColDef<LedgerAccountAgGridRow>[];

const onClickCreateNew = () => openModalLink(ModalTypes.EditLedgerAccount, {});

export const MyAccountsTable = () => {
  const rowData = useSelector(selectLedgerAccountsAgGridData);

  const hasCreatePermission = useCanCreateLedgerAccountPermission();

  const [showConfirmCreateInAgrinous, toggleShowConfirmCreateInAgrinous] =
    useToggle(false);

  const [showConfirmCreateInXero, toggleShowConfirmCreateInXero] =
    useToggle(false);

  const headerButtons = [
    {
      title: "Create New Account",
      isDisabled: !hasCreatePermission,
      onClick: onClickCreateNew,
      default: true,
      icon: faPlus,
    },
    {
      title: "Auto Create (in AgriNous)",
      isDisabled: !hasCreatePermission,
      onClick: toggleShowConfirmCreateInAgrinous,
      icon: faPlus,
    },
    {
      title: "Auto Create (in Xero)",
      isDisabled: !hasCreatePermission,
      onClick: toggleShowConfirmCreateInXero,
      icon: faPlus,
    },
  ];

  return (
    <>
      <AgGridContainer
        rowData={rowData}
        columnDefs={columnDefs}
        tableName={AgGridTables.LEDGER_ACCOUNTS}
        additionalActions={headerButtons}
        downloadFilename="ledgerAccounts.csv"
      />
      <AutoCreateInAgrinousConfirmation
        toggleShowConfirm={toggleShowConfirmCreateInAgrinous}
        open={showConfirmCreateInAgrinous}
      />

      <AutoCreateInXeroConfirmation
        toggleShowConfirm={toggleShowConfirmCreateInXero}
        open={showConfirmCreateInXero}
      />
    </>
  );
};
